export enum AppRoute {
  QRCODE = "qrcode",
  SIGNATURE_CONTRAT = "signature-contrat",
  DL_APP = "telecharger-application",
  SUBSCRIPTION = "adhesion",
  WELCOME = "bienvenue",
  PERSONAL_INFORMATIONS = "vos-informations",
  BANK_DETAILS = "vos-coordonnees-bancaires",
  E_SIGNATURE = "signature",
  CONGRATULATIONS = "felicitations",
  BALISE_RX = "balise-rx",
  PACK_ZERO_FRANCHISE = "pack-zero-franchise",
}
